<div class="govuk-!-margin-bottom-6">
  <h3 class="govuk-heading-m">Product {{ index() + 1 }}</h3>

  <div class="govuk-grid-row govuk-!-margin-bottom-2">
    <div class="govuk-grid-column-three-quarters">
      <div formControlName="productName" widthClass="govuk-!-width-full" govuk-text-input label="Product name"></div>
    </div>

    @if (canRemove()) {
      <div class="govuk-grid-column-one-quarter govuk-!-padding-top-6">
        <button type="button" class="govuk-button govuk-button--secondary govuk-!-margin-bottom-0" (click)="onRemove()">
          Remove product
        </button>
      </div>
    }
  </div>

  <div
    [options]="baselineYearOptions()"
    widthClass="govuk-!-width-one-quarter"
    formControlName="baselineYear"
    govuk-select
    label="Baseline year"
  ></div>

  <div
    formControlName="baselineVariableEnergy"
    govuk-text-input
    widthClass="govuk-!-width-one-quarter"
    label="Baseline variable energy"
    hint="This value may be entered as zero"
    inputType="number"
    [suffix]="facilityUnit()"
  ></div>

  <div
    formControlName="baselineThroughput"
    widthClass="govuk-!-width-one-quarter"
    govuk-text-input
    label="Baseline year throughput"
    hint="For facilities where SRM is used, this must be the adjusted throughput"
  ></div>

  <div
    formControlName="throughputUnit"
    widthClass="govuk-!-width-one-quarter"
    govuk-text-input
    label="Throughput unit"
  ></div>

  <div class="govuk-form-group govuk-!-margin-top-4">
    <p class="govuk-label govuk-label--s">Energy intensity</p>
    <p class="govuk-hint">Automatically calculated</p>
    <p class="govuk-!-margin-bottom-0">
      @if (energyIntensityDisplay(); as intensity) {
        {{ intensity }}
      } @else {
        --
      }
    </p>
  </div>
</div>
